import { GenerationSkeleton } from '@components/generation/generation.skeleton';
import {
  GenerationList,
  GenerationRow
} from '@components/generation/generation-row';
import { EmptyBoxIcon } from '@components/icons/EmptyBoxIcon';
import { useGenerations } from '@/hooks/queries/generations/useGenerations';

type Props = {
  processId: string;
};

export const LastGenerations = ({ processId }: Props) => {
  const { generations, isLoading } = useGenerations({
    processId,
    take: 3,
    withCount: false
  });

  if (isLoading) {
    return (
      <GenerationList>
        {Array.from({ length: 3 }).map((_, index) => (
          <GenerationSkeleton
            index={index}
            isFirst={index === 0}
            isLast={index === 2}
            key={index}
          />
        ))}
      </GenerationList>
    );
  }

  if (generations.length === 0) {
    return (
      <div className="flex flex-col items-center gap-3 py-6">
        <EmptyBoxIcon className="size-16" />
        <p className="text-center text-muted-foreground text-sm">
          This process has not been generated yet
        </p>
      </div>
    );
  }

  return (
    <GenerationList>
      {generations.map((generation, index) => (
        <GenerationRow
          generation={generation}
          isFirst={index === 0}
          isLast={index === generations.length - 1}
          key={generation.id}
          to={`/${processId}/generation/${generation.id}`}
        />
      ))}
    </GenerationList>
  );
};
